/* Mesmerize · Five Worlds · mes-five-worlds.js (no dependencies; ES5-style for old Android)
   Toggle: tap a tab opens it; tap the open tab follows its Experience it link (V9.28.349), or closes it when it has none.
   Canvases: the theme's shared HeroEngine (assets/hero-engine.js, window.__mesHeroEngine). Every canvas is attached once
   the section nears the screen, so opening never blinks. The engine's per-canvas visibility is replaced by ours: a canvas
   draws only while its tab is on screen, wider than 1px and not open (the open tab's canvas stops after its .6s fade).
   Canvas sizes are PINNED in px to each tab's FINAL size, set once per toggle, so nothing resizes while tabs animate
   (an engine resize clears the canvas and re-bakes its sprites); any resize is repainted in the same frame.
   Still images instead of canvases: mode "off", mode "lowend" on weak devices, reduced motion, window.MES_SLOW. */
(function () {
  'use strict';
  var FADE = 650; /* canvas fade-out (.6s) + margin */
  var DESK = '(min-width: 900px)';

  function lowEnd() {
    var n = navigator, c = n.connection || {};
    return (n.deviceMemory > 0 && n.deviceMemory <= 4) || (n.hardwareConcurrency > 0 && n.hardwareConcurrency <= 4) || c.saveData === true;
  }
  function mq(q) { try { return matchMedia(q).matches; } catch (e) { return false; } }
  function px(v) { v = (v || '').trim(); return /vh$/.test(v) ? innerHeight * parseFloat(v) / 100 : parseFloat(v) || 0; }

  /* Shared, retrying engine load: the same queue as footer.liquid / mes-collection-hero.liquid (window.__mesEngineQ +
     __mesEngineLoading), so they never inject hero-engine.js twice while one request is in flight. */
  function engine(src, cb) {
    if (window.HeroEngine) { cb(); return; }
    var q = window.__mesEngineQ = window.__mesEngineQ || [];
    q.push(cb);
    if (window.__mesEngineLoading) return;
    window.__mesEngineLoading = true;
    var tries = 0;
    (function go() {
      var s = document.createElement('script');
      s.src = src; s.defer = true;
      s.onload = function () {
        window.__mesEngineLoading = false;
        var w = q.splice(0, q.length);
        for (var i = 0; i < w.length; i++) { try { w[i](); } catch (e) {} }
      };
      s.onerror = function () {
        if (s.parentNode) s.parentNode.removeChild(s);
        if (++tries < 2) setTimeout(go, 600); else { window.__mesEngineLoading = false; q.length = 0; }
      };
      document.head.appendChild(s);
    })();
  }

  /* The engine has no per-canvas detach; remove our records through its public fields (cvs, order, _ro, _io). */
  function detach(eng, key) {
    var c = eng.cvs && eng.cvs[key]; if (!c) return;
    if (c._ro) c._ro.disconnect();
    if (c._io) c._io.disconnect();
    delete eng.cvs[key];
    var o = eng.order || [], k = o.indexOf(key); if (k >= 0) o.splice(k, 1);
  }

  /* Run fn once the document is shown (prerendered or background documents suspend rAF and transitions). */
  function fillStills(root) {
    root.querySelectorAll('img.mfw__still[data-src]').forEach(function (im) {
      if (im.getAttribute('data-srcset')) im.srcset = im.getAttribute('data-srcset');
      im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
    });
  }
  function goStill(root) { root.classList.add('mfw--still'); fillStills(root); }

  function whenShown(fn) {
    if (document.prerendering) { document.addEventListener('prerenderingchange', function () { whenShown(fn); }, { once: true }); return; }
    if (document.hidden) {
      var h = function () { if (!document.hidden) { document.removeEventListener('visibilitychange', h); whenShown(fn); } };
      document.addEventListener('visibilitychange', h); return;
    }
    if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 1500 }); else setTimeout(fn, 250);
  }

  function init(root) {
    if (root.__mfw) return;
    var tabs = [].slice.call(root.querySelectorAll('[data-mfw-w]')), n = tabs.length;
    var btns = tabs.map(function (t) { return t.querySelector('[data-mfw-btn]'); });
    var wraps = tabs.map(function (t) { return t.querySelector('.mfw__cv'); });
    var cvs = tabs.map(function (t) { return t.querySelector('canvas[data-sig]'); });
    var open = -1;
    tabs.forEach(function (t, i) { if (t.classList.contains('is-open')) open = i; });
    var cvOff = tabs.map(function (t, i) { return i === open; }); /* open tab's canvas has faded out: stop drawing it */
    var onScr = tabs.map(function () { return false; });
    var timers = [], zsz = [], keys = [], obs = [], settleT = 0, fallbackT = 0, live = false, dead = false;
    var api = { tabs: tabs, set: set, destroy: destroy };
    root.__mfw = api;

    /* Persistent men/women view (4 Nov 2026): a world marked for one gender (data-g-card, hidden by snippets/mes-gender)
       drops out for the other; the rest share the height, the numbers close up, and an open world that disappears closes. */
    function vis(t) { return getComputedStyle(t).display !== 'none'; }
    function shown() { var c = 0; for (var i = 0; i < n; i++) if (vis(tabs[i])) c++; return c || n; }
    function renum() {
      var c = 0;
      tabs.forEach(function (t) { if (!vis(t)) return; c++; var el = t.querySelector('[data-mfw-num]'); if (el) el.textContent = (c < 10 ? '0' : '') + c + '.'; });
    }
    function onGender() {
      renum();
      if (open >= 0 && !vis(tabs[open])) set(-1);
      else if (live) { var pw = tabs[0] ? tabs[0].clientWidth : 0; for (var k = 0; k < n; k++) fit(k, pw, finalH(k, open)); }
    }
    document.addEventListener('mes:gender', onGender);
    renum();

    /* Canvas wrapper size for tab i at padding-box size pw x ph. zoom k > 0 (design's data-zoom): squarer canvas,
       s = short + (long - short) * k, wrapper max(tab, s). Otherwise widen% of the tab width (Natural Stone 124%). */
    function fit(i, pw, ph) {
      var z = wraps[i]; if (!z || !pw || !ph) return;
      var k = +z.getAttribute('data-zoom') || 0, W, H;
      if (k > 0) { var lo = Math.min(pw, ph), s = lo + (Math.max(pw, ph) - lo) * k; W = Math.max(pw, s); H = Math.max(ph, s); }
      else { W = pw * (parseFloat(z.getAttribute('data-widen')) || 100) / 100; H = ph; }
      /* data-fmax: cap the canvas at this many tab heights so the focal glyph fits the strip (spiritual: the Om is drawn at
         about 0.134 x the canvas's short side, so 5.6 strips keeps it inside a closed tab with a little room) */
      var fmx = parseFloat(z.getAttribute('data-fmax'));
      if (fmx > 0 && H > ph * fmx) H = Math.max(ph, ph * fmx);
      W = Math.round(W); H = Math.round(H);
      var c = zsz[i]; if (c && c[0] === W && c[1] === H && c[2] === ph) return;
      z.style.width = W + 'px'; z.style.height = H + 'px'; zsz[i] = [W, H, ph];
      /* V9.28.220 (Shrey 15 Oct: "the Om symbol should always be visible in the slit"): data-fy = where the animation's
         focal point sits (spiritual: the Om, drawn at 36% down). The canvas is centred by default, so on a short closed tab a
         focal point above the middle fell outside the strip. Shift it so the focal point lands mid-strip, never leaving a gap. */
      var fy = parseFloat(z.getAttribute('data-fy'));
      if (fy >= 0) { z.style.top = Math.round(Math.min(0, Math.max(ph - H, ph / 2 - fy * H))) + 'px'; z.style.transform = 'translate(-50%,0)'; }
    }
    function fitNow() { for (var i = 0; i < n; i++) fit(i, tabs[i].clientWidth, tabs[i].clientHeight); }
    /* Final padding-box height of tab k once `sel` is open (-1 = none), from the same custom properties the CSS uses:
       each tab = (section height - top space - n borders) * its flex / total flex. */
    function finalH(k, sel) {
      var cs = getComputedStyle(root), d = mq(DESK), r = parseFloat(cs.getPropertyValue('--mfw-ratio')) || 4.6;
      var H = px(cs.getPropertyValue(sel >= 0 ? (d ? '--mfw-ho-d' : '--mfw-ho-m') : (d ? '--mfw-hc-d' : '--mfw-hc-m')));
      if (sel >= 0) H = Math.max(H, px(cs.getPropertyValue('--mfw-hc-m')));
      var P = px(cs.getPropertyValue(d ? '--mfw-pt-d' : '--mfw-pt-m'));
      var nv = shown();
      return Math.max(0, (H - P - nv) * (k === sel ? r : 1) / (sel >= 0 ? nv - 1 + r : nv));
    }

    function set(i) {
      var pw = tabs[0] ? tabs[0].clientWidth : 0; /* read before the class changes: no forced layout */
      open = i;
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-open', on);
        if (btns[k]) btns[k].setAttribute('aria-expanded', on ? 'true' : 'false');
        clearTimeout(timers[k]);
        if (on) timers[k] = setTimeout(function () { cvOff[k] = true; }, FADE); else cvOff[k] = false;
      });
      root.classList.toggle('is-any-open', i >= 0);
      if (live) for (var k = 0; k < n; k++) fit(k, pw, finalH(k, i));
    }
    /* V9.28.349 (Shrey 30 Oct): tapping the OPEN world goes where its "Experience it" button goes (it used to close the world);
       with no button it still closes. Not in the theme editor, where a tap must stay a tap. */
    btns.forEach(function (b, i) { if (b) b.addEventListener('click', function () {
      if (open === i) {
        var cta = tabs[i] && tabs[i].querySelector('.mfw__cta');
        if (cta && cta.href && !(window.Shopify && window.Shopify.designMode)) { window.location.href = cta.href; return; }
        set(-1); return;
      }
      set(i);
    }); });

    var mode = root.getAttribute('data-anim') || 'full';
    var still = mode === 'off' || mq('(prefers-reduced-motion: reduce)') || window.MES_SLOW === true || (mode === 'lowend' && lowEnd());
    if (still) { goStill(root); return; }
    if (!cvs.some(Boolean)) return;

    function start() {
      if (dead || live || !window.HeroEngine || root.classList.contains('mfw--still')) return;
      try {
        var st = root.querySelector('[data-mfw-stones]');
        if (st && !window.MES_HERO_STONES) window.MES_HERO_STONES = JSON.parse(st.textContent);
        var eng = window.__mesHeroEngine || (window.__mesHeroEngine = new window.HeroEngine({}));
        api.eng = eng;
        fitNow(); /* pin sizes before attach so the engine's first resize is the real one */
        if (window.IntersectionObserver) {
          var tio = new IntersectionObserver(function (es) {
            es.forEach(function (e) { var k = tabs.indexOf(e.target); if (k >= 0) onScr[k] = e.isIntersecting; });
          }, { threshold: 0 });
          tabs.forEach(function (t) { tio.observe(t); });
          obs.push(tio);
        } else onScr = onScr.map(function () { return true; });
        var id = root.id || 'mfw', byEl = [];
        cvs.forEach(function (cv, i) {
          if (!cv) return;
          var key = id + '-' + i;
          detach(eng, key); /* editor re-render with the same section id */
          eng.attach(key, cv, cv.getAttribute('data-sig'));
          var c = eng.cvs[key]; if (!c) return;
          keys.push(key); byEl.push([cv, c]);
          /* replace the engine's per-canvas IntersectionObserver with our rule; its loop reads c.visible every frame */
          if (c._io) { c._io.disconnect(); c._io = null; }
          Object.defineProperty(c, 'visible', {
            configurable: true,
            get: function () { return onScr[i] && !cvOff[i] && c.w > 1; },
            set: function () {}
          });
        });
        if (window.ResizeObserver) {
          /* Created AFTER the engine's own per-canvas observers, so it runs after their resize() cleared the backing
             store, in the same frame: repaint now instead of showing a blank frame until the next engine tick. */
          var rp = new ResizeObserver(function (es) {
            var t = performance.now() / 1000;
            es.forEach(function (e) {
              for (var j = 0; j < byEl.length; j++) if (byEl[j][0] === e.target) {
                var c = byEl[j][1], fn = eng.render && eng.render[c.renderKey];
                if (fn && c.visible) { try { fn(c, t); } catch (x) {} }
              }
            });
          });
          byEl.forEach(function (p) { rp.observe(p[0]); });
          obs.push(rp);
          /* window resize / theme editor width changes: re-pin once the tabs settle (never mid-transition) */
          var ro = new ResizeObserver(function () {
            clearTimeout(settleT); settleT = setTimeout(function () { if (!dead) fitNow(); }, 160);
          });
          tabs.forEach(function (t) { ro.observe(t); });
          obs.push(ro);
        }
        live = true;
        clearTimeout(fallbackT);
        root.classList.add('mfw--live');
      } catch (e) { goStill(root); }
    }

    function load() {
      if (dead) return;
      engine(root.getAttribute('data-engine'), start);
      /* engine never arrived (both tries failed, maybe inside another section's shared request): show stills */
      fallbackT = setTimeout(function () { if (!live && !dead) goStill(root); }, 10000);
    }
    if (window.IntersectionObserver) {
      var nio = new IntersectionObserver(function (es) {
        if (!es.some(function (e) { return e.isIntersecting; })) return;
        nio.disconnect(); whenShown(load);
      }, { rootMargin: '200px 0px' });
      nio.observe(root); obs.push(nio);
    } else whenShown(load);

    function destroy() {
      dead = true;
      obs.forEach(function (o) { o.disconnect(); });
      timers.forEach(clearTimeout); clearTimeout(settleT); clearTimeout(fallbackT);
      if (api.eng) keys.forEach(function (k) { detach(api.eng, k); });
      document.removeEventListener('mes:gender', onGender);
      root.__mfw = null;
    }
  }

  function boot(scope) { [].forEach.call((scope || document).querySelectorAll('[data-mfw]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    [].forEach.call(e.target.querySelectorAll('[data-mfw]'), function (r) { if (r.__mfw) r.__mfw.destroy(); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var w = e.target.closest && e.target.closest('[data-mfw-w]'), r = w && w.closest('[data-mfw]');
    if (!r || !r.__mfw) return;
    var i = r.__mfw.tabs.indexOf(w);
    if (i >= 0 && !w.classList.contains('is-open')) r.__mfw.set(i);
  });
})();
